export default function onEnterProp(action: () => any): {
   onKeyDown: React.KeyboardEventHandler<HTMLElement>
} {
   return {
      onKeyDown: ev => {
         if (ev.key === 'Enter') {
            ev.preventDefault()
            action()
         }
      },
   }
}
